import FormattedMessage from 'I18n/components/FormattedMessage';
import ErrorBoundary from 'framework-listing-lib/internal/ErrorBoundary';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function ErrorCell() {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-alert-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.error.cellError.message"
    })
  });
}
export default function ListingLibErrorBoundaryCell({
  children,
  fingerprint,
  wrapWithTd
}) {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    errorComponent: wrapWithTd ? /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx(ErrorCell, {})
    }) : /*#__PURE__*/_jsx(ErrorCell, {}),
    fingerprint: fingerprint,
    children: children
  });
}